import React from "react";
import styled from "styled-components/macro";
import add_scooter from "../../../images/ride/add_scooter_stand.png";
import add_bicycle from "../../../images/ride/add_bicycle_stand.png";

const AddRideUnit = ({ setRideItems }) => {
  const AddNewRideUnit = (type) => {
    setRideItems((oldItems) => [...oldItems, { type: type, items: [] }]);
  };

  return (
    <Wrapper>
      <AddButton
        onClick={() => {
          AddNewRideUnit("scooter");
        }}
      >
        <Img src={add_scooter} />
      </AddButton>
      <AddButton onClick={() => AddNewRideUnit("bicycle")}>
        <Img src={add_bicycle} />
      </AddButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-left: 44px;
  z-index: 100;
  width: 162px;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
`;
const AddButton = styled.button`
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  display: block;
`;

const Img = styled.img`
  width: 55%;
`;

export default AddRideUnit;
